<app-header1></app-header1>
<router-outlet></router-outlet>
<app-footer1></app-footer1>